import React from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import {
  CNavbar,
  CContainer,
  CNavbarBrand,
  CNavbarNav,
  CNavItem,
  CButton,
} from '@coreui/react';
import useAuthViewModel from '../viewmodels/AuthViewModel';

const Navigation = () => {
  const { logout, email } = useAuthViewModel();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <CNavbar colorScheme="light" style={{ backgroundColor: '#25B18E' }}>
        <CContainer fluid>
          <CNavbarBrand 
            className="text-white" 
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/dashboard')}
          >
            SDK Dashboard
          </CNavbarBrand>
          <CNavbarNav className="d-flex flex-row me-auto">
            <CNavItem className="mx-2">
              <NavLink 
                to="/apidoc" 
                className={({ isActive }) => 
                  `text-white text-decoration-none ${isActive ? 'fw-bold' : ''}`
                }
              >
                API
              </NavLink>
            </CNavItem>
          </CNavbarNav>
          <CNavbarNav className="d-flex flex-row">
            <CNavItem>
              <span className="text-white me-3">Welcome, {email}</span>
            </CNavItem>
            <CNavItem>
              <CButton color="light" onClick={handleLogout}>
                Logout
              </CButton>
            </CNavItem>
          </CNavbarNav>
        </CContainer>
      </CNavbar>
    </>
  );
};

export default Navigation;